/* eslint-disable */
import React, { Fragment } from 'react';
import { Button, PageHeader } from 'antd'
import HomePage from '../pages/home'
import Login from '../pages/login'
import { useState } from 'react';
import {
    LogoutOutlined
} from '@ant-design/icons'
import cookies from 'js-cookie'
import {
    v, update_date
} from './../config'

function BasicLayout() {

    const [loginTrue, setLoginTrue] = useState(false);
    
    return (
        <Fragment>
            <PageHeader
                title="Dhandabaz"
                style={{
                    borderBottom: '1px solid red',
                }}
                extra={
                    <Button 
                        hidden={
                            typeof(cookies.get("pin")) === "undefined" && true
                        }
                        style={{backgroundColor: "red", color: "white"}} 
                        icon={<LogoutOutlined />} 
                        onClick={() => {
                            cookies.remove("pin")
                            window.location.href = "/"
                        }}
                    />
                }
            />
            <div key="11" style={{ marginBottom: 10 }}></div>
            <div key="21" style={{ margin: 10 }}>
                {
                    !loginTrue &&
                    <Login
                        login={(e) => {
                            setLoginTrue(e.loginTrue)
                        }}
                    />
                }
                {
                    loginTrue &&
                    <HomePage />
                }
            </div>
            
            <br /> <br />
            <div
                style={{
                    position: "fixed",
                    right: 0,
                    bottom: 0,
                    width: "100%",
                    padding: "10px 16px",
                    borderTop: "1px solid red",
                    background: "#fff",
                    textAlign: "right",
                }}
            >
                <span>{v}</span>
                <br />
                <span>updated: {update_date}</span>
            </div>
        </Fragment>
    );
}

export default BasicLayout;